import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ReactRouter from "web/components/Router";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import "./App.css";
const App = (props) => {
  // let history = useHistory();
  const [initialLogin, setInitialLogin] = useState(true);
  const [name, setName] = useState("");
  const [Password, setPassword] = useState("");
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const onSubmit = () => {
    if (name === "PalletWorld" && Password === "PTL@uncH#J@N2o24") {
      setInitialLogin(true);
    } else {
      setModal(true);
    }
  };
  useEffect(() => {
  }, []);

  const inputStyle = {
    height: '37px',
    borderRadius: '5px',
    border: 'solid 1px #87cdf1',
    width: '240px',
    background: '#ffffff',
    padding: '6px 14px',
    color: '#191819',
  }

  return (
    <div>
      {initialLogin || token ? (
        <div className="App">
          <Helmet title="PalletTrader: Tech-Enabled Pallet Solutions Built Around the Leading Digital Pallet Marketplace">
            <link
              rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/paymentfont/1.2.5/css/paymentfont.min.css"
            />
            <meta
              name="description"
              content="PalletTrader is the leading digital pallet marketplace and order management platform designed to meet the needs of the pallet industry."
            />
            <meta
              name="viewport"
              content="width=device-width initial-scale=1"
            />
            <meta name="description"
              content="A revolutionary marketplace for pallets supply online that will change the way you buy or sell pallets forever. Best place for pallet management on your terms." />
          </Helmet>
          <ReactRouter />
        </div>
      ) : (
        <>
          <h6 style={{
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center',
            marginTop: '51px',
            fontSize: '26px',
            fontFamily: 'latobold'
          }}>Application is undergoing maintenance and we apologize for the inconvenience. We will be back soon!</h6>
          <div
            style={{
              display: "flex",
              minHeight: "calc(100vh - 146px)",
              alignItems: "center",
            }}
          >
            <div
              style={{
                margin: "0 auto",
                boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.16)",
                padding: "30px",
                borderRadius: "12px",
              }}
            >
              <h3 style={{ borderRadius: "5px", marginLeft: "28%", fontSize: '25px', fontFamily: 'latobold' }}>LOGIN</h3>
              <p style={{ borderRadius: "5px", marginTop: "25px" }}>Username</p>
              <input
                style={inputStyle}
                onChange={(e) => setName(e.target.value)}
              />
              <p style={{ borderRadius: "5px", marginTop: "15px" }}>Password</p>
              <input
                type="password"
                style={inputStyle}
                onChange={(e) => setPassword(e.target.value)}
              />
              <br />
              <button
                disabled={name === "" || Password === ""}
                style={{
                  border: "none",
                  background: "#61b01f",
                  borderRadius: "5px",
                  margin: "23px 0 0 27%",
                  padding: '6px 20px',
                  color: "white",
                }}
                onClick={onSubmit}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </>
      )
      }
      <Modal isOpen={modal} centered={true}>
        <ModalBody style={{ textAlign: "center" }}>
          Invalid Credentials
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setModal(false)}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </div >
  );
};

export default App;
